import React, { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown';
import CreateAction from '../../operational/createAction';
import countryCodes from '../../../utils/countryCodes.json'
import PrimaryButton from '../PrimaryButton';
const countryOptions = countryCodes?.map(countryCode => { return { code: countryCode.iso2, name: countryCode.language, emoji: countryCode.emoji } })
const turkishCountryCode = countryOptions.find(countryOption => countryOption.code === "tr")

const DropdownItem = (item) => {
    return <div className=' p-1 text-sm flex flex-row gap-[5px]'>
        {item?.emoji}
        {"\t"}
        {item?.name}
    </div>
}

function LanguageSelector({ type, selectedLanguage, setSelectedLanguage, callback, activeNotification }) {
    const [languageOptions, setLanguageOptions] = useState()
    const getLanguageAndRegions = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/getLocalizations`,
            showPreLoader: true,
            isFileUploading: false,

        });
        if (!response.result.resultData) return
        const languageAndRegions = response?.result.resultData
        try {

            const optionDataObject = {}
            languageAndRegions?.forEach((childTheme) => {
                const ThemeVariant = childTheme.ThemeVariant
                optionDataObject[ThemeVariant.id] = {
                    code: ThemeVariant.id,
                    name: ThemeVariant.name,
                    index: ThemeVariant?.index
                }
            })
            const optionData = Object.values(optionDataObject)
                ?.filter(d => d)?.sort((a, b) => {
                    const indexA = a.index
                    const indexB = b.index
                    return indexA - indexB
                })
            setLanguageOptions(optionData)
            if (activeNotification) {
                setSelectedLanguage(optionData?.find(l => l.code === activeNotification?.language))
            }
            else {
                setSelectedLanguage(optionData[0])
            }
            callback?.({ optionData, selectedOptionData: optionData[0] })
        }
        catch (e) {

        }
    }

    useEffect(() => {
        getLanguageAndRegions()
    }, [])
    return (
        <>
            {type === "dropdown" ?
                <Dropdown
                    filter
                    value={selectedLanguage}
                    className='w-full'
                    itemTemplate={DropdownItem}

                    options={languageOptions}
                    optionLabel='name'
                    onChange={(e) => {
                        setSelectedLanguage(e.value)
                    }}>

                </Dropdown> :
                <div className='flex flex-row'>

                    {languageOptions?.map(languageOption => {

                        return <PrimaryButton value={languageOption.name} ></PrimaryButton>
                    })}
                </div>

            }
        </>
    )
}

export default LanguageSelector